// ** React Imports
import { useState, useEffect, MouseEvent, useCallback, ReactElement } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import { DataGrid, GridEventListener } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography'
import Icon from 'src/features/common/CustomIcon'
import Link from '@mui/material/Link';
// ** Store Imports
import { SelectOption } from 'src/types/common';
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';
// ** Custom Components Imports
import Tooltip from '@mui/material/Tooltip'
import { client } from 'src/utils/axios-client'
import { leadEndpoints } from 'src/configs/endpoints'

import _ from 'lodash'
import { ActivitySummaryDashboardResponse, ActivityType, CadenceListDialogStore, DashboardTodoStore, DashboardViewStore, InboundCallStore, KPISummaryDashboardResponse, Lead, LeadListStore, LeadScreenStore, QuickLeadDialogStore, ViewType } from '../../stores/LeadStore'
import { ActivityColor, colorDateTooltipOverdue, colorDateTooltipOverdueDashboard, nextDateDays, nextDateDaysDashboard } from '../../utils/date-utils'
import VoicemailTwoToneIcon from '@mui/icons-material/VoicemailTwoTone';
import ArrowUpwardTwoToneIcon from '@mui/icons-material/ArrowUpwardTwoTone';
import ArrowDownwardTwoToneIcon from '@mui/icons-material/ArrowDownwardTwoTone';
import TrendingUpTwoToneIcon from '@mui/icons-material/TrendingUpTwoTone';
import TrendingDownTwoToneIcon from '@mui/icons-material/TrendingDownTwoTone';
import StandardSkeleton from '../common/StandardSkeleton';
import CardContent from '@mui/material/CardContent'
import Skeleton from '@mui/material/Skeleton'
import Avatar from '@mui/material/Avatar';
import { Solid } from 'mdi-material-ui';
import PerformanceCard from '../common/PerformanceCard';
import TrendingFlatTwoToneIcon from '@mui/icons-material/TrendingFlatTwoTone';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DashboardKPIDetails from './DashboardKPIDetails';


type Props = {
    userId: string
}


const DashboardKPI = ({ userId }: Props) => {
    const records = KPISummaryDashboardResponse.useState(s => s.record);
    const [reloadRecords, setReloadRecords] = useState<boolean>(false)
    const [dataLoaded, setDataLoaded] = useState<boolean>(false)
    const [selectedCustomer, setSelectedCustomer] = useState<string>('')
    
    useEffect(() => {
        loadRecords(userId);
    }, [reloadRecords, userId])

    const loadRecords = async (userId: string) => {
        const response = await client.get(leadEndpoints.getdashboardkpisummary, { params: { userId } });
        KPISummaryDashboardResponse.update(s => { s.record = response.data });
        setDataLoaded(true);
        setSelectedCustomer(response.data.selectedCustomer);
    }
    const handleCustomerChange = (event: SelectChangeEvent) => {
        setSelectedCustomer(event.target.value as string);
        KPISummaryDashboardResponse.update(s => { s.record.selectedCustomer = event.target.value as string });
    };


    if (dataLoaded) {
        return (
            <Grid container spacing={2} justifyContent={'center'} >
                {records.customerCount > 1 &&
                    <Grid item xs={12} md={12}>

                        <FormControl>
                            <InputLabel id="demo-simple-select-label">Performance - KPIs (Customer)</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedCustomer}
                                label="Performance - KPIs (Customer)"
                                onChange={handleCustomerChange}
                                size='small'
                                sx={{ width: 400 }}
                            >
                                {records.kpiDetails.map(record => (
                                    <MenuItem
                                        key={record.customerId}
                                        value={record.customerId}
                                    >
                                        {record.customerName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                }
                <Grid item xs={12} md={12} >
                    <DashboardKPIDetails title={"Performance - KPIs for This Month"} userId={""} />
                </Grid>
            </Grid>
        )
    }
    else {
        return <Box>
            <Card variant="outlined">
                <CardContent>
                    <Grid item xs={12} md={12} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <Card >
                            <Skeleton variant="text" sx={{ fontSize: 16, ml: 3, mr: 3 }} width={200} />
                        </Card>
                    </Grid>
                    <Grid container spacing={1} justifyContent={'left'}>
                        <Grid item xs={12} md={2.4} sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                            <Skeleton variant="rectangular" width={'100%'} height={90} />
                        </Grid>
                        <Grid item xs={12} md={2.4} sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                            <Skeleton variant="rectangular" width={'100%'} height={90} />
                        </Grid>
                        <Grid item xs={12} md={2.4} sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                            <Skeleton variant="rectangular" width={'100%'} height={90} />
                        </Grid>
                        <Grid item xs={12} md={2.4} sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                            <Skeleton variant="rectangular" width={'100%'} height={90} />
                        </Grid>
                        <Grid item xs={12} md={2.4} sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                            <Skeleton variant="rectangular" width={'100%'} height={90} />
                        </Grid>
                    </Grid>
                </CardContent>
                    
            </Card>

        </Box>
    }

}

export { DashboardKPI }
export default DashboardKPI
